import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePartner } from "@/context/PartnerContext";

export const AnnouncementBar = () => {
  const { isPartner, partner, ready } = usePartner();
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/content").then((r) => setC(r.data || {})).catch(() => {}); }, []);

  if (!c || !ready) return null;
  // Partner shops only ever show the partner's own ticker — never the main-brand announcement.
  const text = isPartner ? (partner?.ticker_text || "").trim() : (c.announcement_enabled ? c.announcement_text : "");
  if (!text) return null;
  const items = Array.from({ length: 4 });

  return (
    <div className="relative z-[60] overflow-hidden py-2" style={{ background: c.announcement_bg || "#0A0A0A", color: c.announcement_fg || "#FAFAFA" }} data-testid="announcement-bar">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((_, i) => (
          <span key={i} className="mono mx-8 text-[11px] font-medium uppercase tracking-[0.2em]">{text}</span>
        ))}
        {items.map((_, i) => (
          <span key={`b-${i}`} className="mono mx-8 text-[11px] font-medium uppercase tracking-[0.2em]" aria-hidden="true">{text}</span>
        ))}
      </div>
    </div>
  );
};
